<template>
  <div>
    <a href="#" v-b-modal="modalID">
      <i class="fa fa-plus"></i>
      Add
    </a>

    <b-modal title="Create categories" :id="modalID" :ref="modalID" no-close-on-esc no-close-on-backdrop hide-footer size="md">
      <p><em> Each item on a separate line e.g:</em></p>
      Category one <br />
      Category two <br />
      Category three <br />
      Etc ...
      <p>&nbsp;</p>
      <form @submit.prevent="createCategories">
        <div class="form-group mb-2">
          <textarea v-model="categoryListString" rows="7" class="form-control form-control-lg" :class="{ 'is-invalid': $v.categoryListString.$error, 'is-valid': !$v.categoryListString.$invalid }"></textarea>
          <div class="invalid-feedback">
            <span v-if="!$v.categoryListString.required">List is required.</span>
          </div>
        </div>
        <button type="submit" class="btn btn-secondary mb-2" :disabled="isDisabled">{{ myButton }}</button>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    clientRef: String,
  },
  data() {
    return {
      modalID: "topCategories",
      categoryListString: "",
      myButton: "Submit",
      isDisabled: false,
    };
  },
  methods: {
    createCategories() {
      this.isDisabled = true;
      this.myButton = "Working... please wait.";

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isDisabled = false;
        return;
      }

      let formData = new FormData();
      formData.append("ref", this.clientRef);
      formData.append("categories", this.categoryListString);
      axios.post(`/team/create/categories`, formData).then((res) => {
        //console.log(res.data);
        if (res.data.status === "success") {
          //this.isDisabled = false;
          //this.myButton = "Submit";
          //this.$refs[this.modalID].hide();
          window.location.reload();
        }
      });
    },
  },
  validations: {
    categoryListString: { required },
  },
};
</script>

<style>
</style>